export interface InvoiceField {
    key: string;
    label: string;
}

// This method is used to get invoice fields
export function getInvoiceFields(): InvoiceField[] {
    return [
     
        { key: 'SR Number', label: 'PAYMENTS.SR_NUMBER' },
        { key: 'DC Parent Invoice Number', label: 'PAYMENTS.DC_PARENT_INVOICE_NUM' },
        { key: 'Invoice Date', label: 'PAYMENTS.INVOICE_DATE' },
        { key: 'DC Exporter Member Num', label: 'PAYMENTS.DC_EXPORTER_MEMBER_NUM' },
        { key: 'DC Name English', label: 'PAYMENTS.DC_NAME_EN' },
        { key: 'DC SRType', label: 'PAYMENTS.DC_SRTYPE' },
        { key: 'DC SRSubType', label: 'PAYMENTS.DC_SRSUBTYPE' },
        { key: 'SR Created By Name', label: 'PAYMENTS.SR_CREATED_BY' },
        { key: 'Total Amount', label: 'PAYMENTS.TOTAL_AMOUNT' },
        { key: 'Total Paid', label: 'PAYMENTS.TOTAL_PAID' },
        { key: 'DC Credit', label: 'PAYMENTS.DC_CREDIT' },
        { key: 'DC Balance Amount', label: 'PAYMENTS.DC_BALANCE_AMOUNT' },
        { key: 'Status', label: 'PAYMENTS.STATUS' },
       
        { key: 'Payment Method', label: 'PAYMENTS.PAYMENT_METHOD' },
        { key: 'Exporter Name English', label: 'PAYMENTS.EXPORTER_NAME_EN' },
        { key: 'DC Debit', label: 'PAYMENTS.DC_DEBIT' },
      
        { key: 'DC Initial Amount', label: 'PAYMENTS.DC_INITIAL_AMOUNT' },
        { key: 'DC Initial Balance', label: 'PAYMENTS.DC_INITIAL_BALANCE' },
    ];
}
